<div class="inline-alert">
    <div *ngIf="type===inlineAlertTypes.info" class="info">{{text | translate}}
        <a *ngIf="link" [routerLink]="[link]">{{linkText | translate}}</a>
    </div>
    <div *ngIf="type===inlineAlertTypes.warning" class="warning">{{text | translate}}
        <a *ngIf="link" [routerLink]="[link]">{{linkText | translate}}</a>
    </div>
    <div *ngIf="type===inlineAlertTypes.error" class="error">{{text | translate}}
        <a *ngIf="link" [routerLink]="[link]">{{linkText | translate}}</a>
    </div>

    <div *ngIf="type===inlineAlertTypes.success" class="success">{{text | translate}}
        <a *ngIf="link" [routerLink]="[link]">{{linkText | translate}}</a>
    </div>
</div>
